import * as lil from 'lil-gui';

export default class Debug {

    constructor() {
        
        //this.active = window.location.hash === '#debug';
        this.active = false;
        this.ui = null;

        if (this.active) {
            this.ui = new lil.GUI();
            
        }
    }
}